
export default function RecruitmentSection() {
  return (
    <section id="recruitment" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            求人情報
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            一緒に地域の健康をサポートしませんか？やりがいのある職場で新しいキャリアをスタートしましょう
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 求人情報テキスト */}
          <div>
            <h3 className="text-2xl font-semibold mb-6 text-gray-900">
              私たちと一緒に働きませんか？
            </h3>
            <p className="text-gray-600 mb-8 leading-relaxed">
              当院では、患者様一人ひとりに寄り添った丁寧な施術を心がけています。
              経験豊富なスタッフがしっかりとサポートしますので、
              新卒の方や経験の浅い方も安心してご応募ください。
            </p>

            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#3cb371] rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-user-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-2 text-gray-900">募集職種</h4>
                  <p className="text-gray-600">柔道整復師・鍼灸師・マッサージ師</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#3cb371] rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-time-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-2 text-gray-900">勤務時間</h4>
                  <p className="text-gray-600">平日 9:00-20:00 / 土日 9:00-18:00<br />シフト制（週休2日）</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#3cb371] rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-money-dollar-circle-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-2 text-gray-900">給与</h4>
                  <p className="text-gray-600">月給 25万円〜35万円<br />経験・能力に応じて優遇</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-8 h-8 bg-[#3cb371] rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-heart-line text-white"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-2 text-gray-900">福利厚生</h4>
                  <p className="text-gray-600">社会保険完備・交通費支給・研修制度充実<br />有給休暇・昇給制度あり</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <button className="whitespace-nowrap cursor-pointer font-medium rounded-full transition-colors duration-200 flex items-center justify-center bg-[#3cb371] text-white hover:bg-[#2e8b57] px-8 py-3 text-base">
                <i className="ri-mail-line mr-2"></i>
                応募・お問い合わせ
              </button>
            </div>
          </div>

          {/* スタッフ写真 */}
          <div className="relative">
            <div className="bg-gradient-to-br from-[#3cb371]/10 to-[#3cb371]/20 rounded-2xl p-8">
              <img
                src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/15feb5e94a5d81e200669258e0d876fe.png"
                alt="当院のスタッフチーム"
                className="w-full h-80 object-cover object-top rounded-xl shadow-lg"
              />
              <div className="mt-6 text-center">
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  アットホームな職場環境
                </h4>
                <p className="text-gray-600">
                  チームワークを大切にし、お互いを支え合いながら
                  患者様により良い施術を提供しています
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* 応募の流れ */}
        <div className="mt-20">
          <h3 className="text-2xl font-semibold text-center mb-12 text-gray-900">
            応募の流れ
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#3cb371] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">1</span>
              </div>
              <h4 className="font-semibold mb-2 text-gray-900">お問い合わせ</h4>
              <p className="text-gray-600 text-sm">
                お電話またはメールにて
                お気軽にお問い合わせください
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#3cb371] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">2</span>
              </div>
              <h4 className="font-semibold mb-2 text-gray-900">書類選考</h4>
              <p className="text-gray-600 text-sm">
                履歴書・職務経歴書を
                ご提出いただきます
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#3cb371] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">3</span>
              </div>
              <h4 className="font-semibold mb-2 text-gray-900">面接</h4>
              <p className="text-gray-600 text-sm">
                院長との面接を行い
                お互いを知る機会とします
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-[#3cb371] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">4</span>
              </div>
              <h4 className="font-semibold mb-2 text-gray-900">入社</h4>
              <p className="text-gray-600 text-sm">
                研修期間を経て
                正式に勤務開始となります
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
